import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 0px 103px;
`;

export const Title = styled.h2`
  text-align: center;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 64px 0px 2px 0px;
`;

export const ProvidersRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const ProvidersContainer = styled.div`
  width: fit-content;
  display: inline-flex;
  column-gap: 50px;
  row-gap: 25px;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
  margin-top: 19px;
  margin-bottom: 47px;
`;

export const EditIconContainer = styled.div`
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  right: -60px;
  top: 25px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
  margin-left: 10px;
`;

export const ImgOutsideContainer = styled.div`
  text-align: center;
  box-sizing: border-box;
  object-fit: contain;
  display: inline-flex;
  column-gap: 50px;
`;

export const ImgContainer = styled.img`
  height: 66px;
  display: inline-block;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  object-fit: contain;
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
`;
